import {get, post, put, _delete} from './Tools';

const getData = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}configuracion_checadas`);
  return response;
};

const update = async (payload) => {
  const response = await put(`${process.env.REACT_APP_SERVER}configuracion_checadas`, payload);
  return response;
};

export { getData, update };